<div class="transfer-body flexRow align-items-stretch">
  <div class="options-body border-1 defaultRadius mr-lg" [ngStyle]="{ width: leftWidth }">
    <div class="body-title flexRow pl-sm">
      <div class="ml-xs">{{ optionsTitle }}</div>
    </div>
    <div class="mt-sm search-box">
      <nz-input-group [nzPrefix]="search_icon">
        <input
          nz-input
          placeholder="输入关键字搜索"
          [(ngModel)]="optionsSearchKey"
          (keydown.enter)="$event.target.blur()"
          (blur)="searchOptions()"
        />
      </nz-input-group>
    </div>
    <ng-template #search_icon>
      <i nz-icon nzIconfont="icon_search" class="text-gray2"></i>
    </ng-template>
    <div class="options-box scroll" [ngStyle]="{ height: scrollHeight }">
      <ng-container *ngFor="let options of data">
        <div class="options-item" *ngIf="optionsSearchKey == '' || options['label'].indexOf(optionsSearchKey) > -1">
          <label nz-checkbox [(ngModel)]="options['checked']" (ngModelChange)="checkLabel(options)">{{ options['label'] }}</label>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="result-body flexFull border-1 defaultRadius">
    <div class="body-title flexRow pl-sm pr-sm">
      <div class="ml-xs mr-xs">已选</div>
      <div class="ml-sm text-gray1">({{ resultData.length }}项)</div>
      <div class="flexFull"></div>
      <div class="text-primary clickEle pr-xs" (click)="clear()">清空</div>
    </div>
    <div class="mt-sm search-box pl-sm pr-sm">
      <nz-input-group [nzPrefix]="search_icon">
        <input
          nz-input
          placeholder="输入关键字搜索"
          [(ngModel)]="resultSearchKey"
          (keydown.enter)="$event.target.blur()"
          (blur)="searchResult()"
        />
      </nz-input-group>
    </div>
    <ng-template #search_icon>
      <i nz-icon nzIconfont="icon_search" class="text-gray2"></i>
    </ng-template>
    <div class="options-box pl-12 pr-12 scroll" [ngStyle]="{ height: scrollHeight }">
      <ng-container *ngFor="let options of resultData">
        <div class="result-item pl-12 pr-12 mb-sm flexRow" *ngIf="resultSearchKey == '' || options['label'].indexOf(resultSearchKey) > -1">
          <div>{{ options['label'] }}</div>
          <div class="flexFull"></div>
          <i
            nz-icon
            nzType="close-circle"
            nzTheme="outline"
            class="text-gray2 clickEle"
            (click)="options['checked'] = false; checkLabel(options)"
          ></i>
        </div>
      </ng-container>
    </div>
  </div>
</div>
